import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides, movies } from '@/mocks/movies';

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(timer);
  }, [total]);

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + total) % total);
  };

  const slide = heroSlides[index];
  const movie = movies.find((m) => m.id === slide.id);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden bg-primary-950">
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={s.banner}
            alt={`${movie?.title ?? ''}剧照`}
            title={`${movie?.title ?? ''} - 诱人的女员工hd影视专区`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <div key={slide.id} className="animate-hero-fade max-w-3xl">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-4">
            {slide.tagline}
          </span>
          <h1 className="font-heading font-black text-background-50 text-3xl md:text-5xl leading-tight">
            {movie?.title}
          </h1>
          <p className="mt-3 text-sm md:text-base text-background-200 max-w-xl mx-auto leading-relaxed">
            {slide.desc}
          </p>
          <div className="mt-6 flex items-center justify-center gap-3 flex-wrap">
            <Link
              to={`/detail/${slide.id}`}
              className="px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看详情
            </Link>
            <Link
              to={movie?.type === 'tv' ? '/category/tv' : '/category/movie'}
              className="px-5 py-2.5 rounded-md bg-background-50/15 text-background-50 text-sm font-medium hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览{movie?.type === 'tv' ? '电视剧' : '电影'}
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(-1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-black/40 text-background-50 hover:bg-black/60 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-black/40 text-background-50 hover:bg-black/60 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((s, i) => (
          <button
            key={s.id}
            type="button"
            aria-label={`切换到第${i + 1}张`}
            onClick={() => setIndex(i)}
            className={`h-2 rounded-full transition-all cursor-pointer ${
              i === index ? 'w-6 bg-accent-500' : 'w-2 bg-background-50/50'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}